export const brandName = [
  { label: "Tasla", id: 6 },
  { label: "BMW", id: 7 },
  { label: "Ferrari", id: 8 },
  { label: "Ford", id: 9 },
  { label: "Porsche", id: 10 },
  { label: "Honda", id: 130 },
  { label: "Toyota", id: 10 },
  { label: "Bentley", id: 10 },
  { label: "Maserati", id: 10 },
  { label: "Audi", id: 10 },
];

export const modelName = [
  { label: "Tata Skoda", id: 6 },
  { label: "MG Motor Mercedes Benz", id: 7 },
  { label: "Land Rover Kia", id: 8 },
  { label: "Jaguar Hyundai", id: 9 },
  { label: "BMW Audi", id: 10 },
  { label: "Maruti Suzuki Honda", id: 130 },
  { label: "Mahindra Nissan", id: 10 },
  { label: "Datsun Toyota", id: 10 },
];
